export default "__VITE_ASSET__1d06bc8a__"